import {obtenerReservacionesEntreFechasOcupacion} from "./obtenerReservacionesEntreFechasOcupacion";
import {FECHACHECKIN, FECHACHECKOUT} from "../Constantes";

export const obtenerOcupacionEntreFechas = async ({fechaInicio, fechaFin}) => {

    let reservaciones = await obtenerReservacionesEntreFechasOcupacion({fechaInicio: fechaInicio, fechaFin: fechaFin})

    let nochesOcupado = obtenerNumOcupadoNochesDesde(reservaciones, fechaInicio, fechaFin)


    return nochesOcupado

}

const obtenerNumOcupadoNochesDesde = (reservaciones, fechaInicio, fechaFin) => {

    let unaHoraMiliSegundos = 1000 * 60 * 60
    let unaDiaMiliSegundos = unaHoraMiliSegundos * 24

    let tiempoOcupado = 0
    for (let i = 0; i < reservaciones.length; i++) {
        let reservacion = reservaciones[i]

        if (reservacion[FECHACHECKIN] < fechaInicio) {
            let ocupacionMes = fechaInicio - reservacion[FECHACHECKOUT] - unaHoraMiliSegundos
            tiempoOcupado = tiempoOcupado + (ocupacionMes * -1)
        }
        if (reservacion[FECHACHECKIN] > fechaFin) {
            let ocupacionMes = fechaFin - reservacion[FECHACHECKIN] - unaHoraMiliSegundos
            tiempoOcupado = tiempoOcupado + (ocupacionMes * -1)
        } else {
            let ocupacionMes = reservacion[FECHACHECKIN] - reservacion[FECHACHECKOUT] - unaHoraMiliSegundos
            tiempoOcupado = tiempoOcupado + (ocupacionMes * -1)
        }


    }

    return tiempoOcupado / unaDiaMiliSegundos

}